import { isEmpty } from 'lodash-es';
import { useMenuStore } from '../../../stores';
import { SubCategoryLink } from '../SubCategoryLink';
import { ChildCategoryLink } from '../ChildCategoryLink';
import { SubCategoryAd } from '../SubCategoryAd';
import { Accordion } from '../Accordion';
import { BrandLink } from '../BrandLink';

export function MenuMobilePanel() {
  const selectedCategory = useMenuStore.use.selectedCategory();
  const selectedSubCategory = useMenuStore.use.selectedSubCategory();
  const setSelectedSubCategory = useMenuStore.use.setSelectedSubCategory();

  const brandIcons = selectedSubCategory?.otherAds?.brandIcons ?? [];

  const hasBrandIcons = brandIcons.length > 0;
  const isSubCategoryAdVisible = !isEmpty(selectedSubCategory?.categoryAds);

  return (
    <div className="tlw-grid tlw-grid-cols-[3.75fr_6.25fr] tlw-overflow-hidden">
      {/* 左側中類選單 */}
      <div className="tlw-scrollbar | tlw-py-5 tlw-bg-white tlw-overflow-y-auto tlw-overscroll-contain">
        <ul className="tlw-space-y-2">
          {selectedCategory?.subCategories.map((item) => (
            <li key={`${item.categoryId}_${item.title}`}>
              <SubCategoryLink
                category={item}
                isActive={
                  item.title === selectedSubCategory?.title &&
                  item.categoryId === selectedSubCategory?.categoryId
                }
                onClick={(e) => {
                  Boolean(item.subCategories?.length) && e.preventDefault();
                  setSelectedSubCategory(item);
                }}
              />
            </li>
          ))}
        </ul>
      </div>

      {/* 右側小類面板 */}
      <div className="tlw-scrollbar | tlw-bg-gray-100 tlw-overflow-y-auto tlw-overscroll-contain">
        {/* 小類選單 */}
        <ul className="tlw-py-5 empty:tlw-py-0">
          {selectedSubCategory?.subCategories.map((item) => (
            <li key={`${item.categoryId}_${item.title}`}>
              {!item.subCategories.length ? (
                <ChildCategoryLink
                  className="tlw-mx-5 tlw-my-1"
                  category={item}
                />
              ) : (
                <Accordion label={item.title}>
                  <ul className="tlw-px-5 tlw-pb-3">
                    {item.subCategories.map((item) => (
                      <li className="tlw-my-1" key={item.title}>
                        <ChildCategoryLink
                          category={item}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </li>
                    ))}
                  </ul>
                </Accordion>
              )}
            </li>
          ))}

          {/* 品牌推薦 */}
          {hasBrandIcons && (
            <li>
              <Accordion label="品牌推薦">
                <ul className="tlw-px-5 tlw-py-2 tlw-grid tlw-grid-cols-2 tlw-gap-4">
                  {brandIcons.map((item) => (
                    <li key={item.link}>
                      <BrandLink
                        categoryAd={item}
                        onClick={(e) => e.stopPropagation()}
                      />
                    </li>
                  ))}
                </ul>
              </Accordion>
            </li>
          )}
        </ul>

        {/* 中類廣告 */}
        {isSubCategoryAdVisible && <SubCategoryAd />}
      </div>
    </div>
  );
}
